export default __webpack_public_path__ + "static/media/HTML.b134f624.webp";